import { ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseFormComponent } from '../base-form/base-form.component';

@Component({
  selector: 'app-date-range-form',
  templateUrl: './date-range-form.component.html',
  styleUrls: ['./date-range-form.component.scss'],
})
export class DateRangeFormComponent extends BaseFormComponent {
  constructor(translator: TranslateService, changeDetection: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
    super(
      translator,
      changeDetection,
      formBuilder.group({
        from: [null, Validators.required],
        to: [null, Validators.required],
      })
    );
  }
}
